function extractBookBuyUrl(root) {
    const meta = root.querySelector('meta[name="book-buy-url"]');

    if (meta) {
        const content = meta.getAttribute("content");
        if (content) {
            return content.trim();
        }
    }

    const textNodeContainers = [root.head, root.body].filter(Boolean);
    for (const container of textNodeContainers) {
        const nodes = Array.from(container.childNodes);

        for (const node of nodes) {
            if (node.nodeType !== Node.TEXT_NODE) {
                continue;
            }

            const value = node.textContent.trim();
            if (!/^https?:\/\/\S+$/i.test(value)) {
                continue;
            }

            node.textContent = "";
            return value;
        }
    }

    return "";
}

function getBookBuyUrl() {
    return extractBookBuyUrl(document);
}

async function fetchBookBuyUrl(postUrl) {
    try {
        const response = await fetch(postUrl);
        if (!response.ok) {
            return "";
        }

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, "text/html");
        return extractBookBuyUrl(doc);
    } catch (error) {
        return "";
    }
}

function enhanceSingleBookButton() {
    const actions = document.querySelector("[data-book-buy-actions]");
    const link = document.querySelector("[data-book-buy-link]");

    if (!actions || !link) {
        return;
    }

    const buyUrl = getBookBuyUrl();
    if (!buyUrl) {
        return;
    }

    link.setAttribute("href", buyUrl);
    actions.hidden = false;
}

async function enhanceBookListingButtons() {
    const listingCards = Array.from(document.querySelectorAll(".rb-book-row, .tag-book .gh-card"));

    await Promise.all(listingCards.map(async (card) => {
        const postLink = card.querySelector('a[href]');
        if (!postLink) {
            return;
        }

        let actions = card.querySelector("[data-book-listing-actions]");
        let link = actions?.querySelector("[data-book-buy-link]");

        if (!actions) {
            const target = card.querySelector(".gh-card-content");
            if (!target) {
                return;
            }

            actions = document.createElement("div");
            actions.className = "rb-book-actions";
            actions.hidden = true;
            actions.setAttribute("data-book-listing-actions", "");
            actions.innerHTML = '<a class="gh-button" href="#" target="_blank" rel="noopener noreferrer" data-book-buy-link>ՈՒՆԵՆԱԼ 5 ՕՐԻՑ</a>';
            target.appendChild(actions);
            link = actions.querySelector("[data-book-buy-link]");
        }

        if (!link) {
            return;
        }

        const buyUrl = await fetchBookBuyUrl(postLink.href);
        if (!buyUrl) {
            return;
        }

        link.setAttribute("href", buyUrl);
        actions.hidden = false;
    }));
}

async function enhancePartnerTitleLinks() {
    const titleLinks = Array.from(document.querySelectorAll(".rb-card--dynamic-partner [data-partner-title-link]"));

    await Promise.all(titleLinks.map(async (titleLink) => {
        const sourceUrl = titleLink.getAttribute("data-source-post-url") || titleLink.getAttribute("href");
        if (!sourceUrl) {
            return;
        }

        const injectedUrl = await fetchBookBuyUrl(sourceUrl);
        if (!injectedUrl) {
            return;
        }

        titleLink.setAttribute("href", injectedUrl);
        titleLink.setAttribute("target", "_blank");
        titleLink.setAttribute("rel", "noopener noreferrer");
    }));
}

export default function bookBuyButton() {
    enhanceSingleBookButton();
    enhanceBookListingButtons();
    enhancePartnerTitleLinks();
}
